module.exports = __webpack_public_path__ + "static/media/paulina.69b94ec4.jpg";